import { BenchmarkMetricName } from "app/pages/benchmark-tracker/types/api.types";

export const COMPETITORS_MODAL_WIDTH = "800px";
export const COMPETITORS_MODAL_WIDTH_BIG = "940px";

export const bigModalsMetrics = [BenchmarkMetricName.trafficShare, BenchmarkMetricName.audienceReach];

export const CONTENT_STYLES = { padding: 0, width: COMPETITORS_MODAL_WIDTH, maxHeight: "635px" };
